import { Table } from 'antd'
import { giftCardColumn } from '../../customers/column'

const GiftCardTable = ({ data, setData, setOpen, setOpenDeleteModal, getModulePermission }) => {
  return (
    <div>
        <Table dataSource={data || []} columns={giftCardColumn(setData, setOpen, setOpenDeleteModal, getModulePermission)} pagination={false} />
    </div>
  )
}

export default GiftCardTable
